import { createSelector } from 'reselect'

export const paymentMethodsSupport = createSelector(
    [state => state.RestaurantReducer],
    restaurant => restaurant?.paymentMethodsSupport || []
)